import { useRef } from 'react'

/**
 * 我们的版本没有，自己实现一个
 * https://ahooks.gitee.io/zh-CN/hooks/use-memoized-fn
 * @param fn
 * @returns
 */
export const useMemoizedFn = <F extends (...args: any[]) => any>(fn: F) => {
  const ref0 = useRef<F>()
  const ref = useRef(fn)
  ref.current = fn
  ref0.current =
    ref0.current ??
    (function (this: any, ...args) {
      return ref.current.call(this, ...args)
    } as F)
  return ref0.current
}
